import { useTranslation } from 'react-i18next'

import Button from '../../Button'

import { QA_NAME_DOC_FLOW_EPOST_VALIDATION_PREVIEW_BUTTON } from './DocFlowEpostValidationPreviewButton.constants'

import * as styles from './DocFlowEpostValidationPreviewButton.module.css'

import ErrorIcon from '../../../icons/error.svg'

function DocFlowEpostValidationPreviewButton({ onClick, ...restProps }) {
  const { t } = useTranslation()

  return (
    <Button.Icon
      {...restProps}
      Icon={ErrorIcon}
      className={styles.DocFlowEpostValidationPreviewButton}
      qaName={QA_NAME_DOC_FLOW_EPOST_VALIDATION_PREVIEW_BUTTON}
      tooltip={t('DocFlow.EpostValidationPreviewButtonTooltipKey')}
      onClick={onClick}
    />
  )
}

export default DocFlowEpostValidationPreviewButton
